export const FETCH_SUBSCRIBERS = "subscriber/fetch";
export const CREATE_SUBSCRIBER = "subscriber/create";
export const DELETE_SUBSCRIBER = "subscriber/delete";
export const UPDATE_SUBSCRIBER = "subscriber/update";
export const IMPORT_SUBSCRIBERS = "subscriber/import";
export const FETCH_SUBSCRIBER_MEMBERS = "subscriberMembers/get";
export const FETCH_SUBSCRIBER_COURSES = "subscriberCourses/get";
export const FETCH_SUBSCRIBER_COURSE_ENROLLEDMEMBERS="subscriberCourseEnrolledMembers/get"
export const FETCH_SUBSCRIBER_COURSE_JOURNALIST="subscriberCourseJournalist/get"